module.exports = __webpack_public_path__ + "static/media/reserch_products_cn01.aef1aecd.png";